'use strict'
const contentful = require('contentful')

const SPACE_ID = 'tozpqc112hge'
const ACCESS_TOKEN = 'c680e5fd35cfc901db7bf350a1ce460d955573dbe79d7836e0d064a80dce5d6f'

const client = contentful.createClient({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: SPACE_ID,
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: ACCESS_TOKEN
})

// Entry point of the boilerplate, called at the end.
function runBoilerplate (callback) {
  displayContentTypes()
    .then(displayEntries)
    .then(data => {
      if (callback) callback(data)
    })
    .catch((error) => {
      if (error.stack) {
        console.error(error.stack)
        return
      }
      console.error(error)
    })
}

function displayContentTypes () {
  return fetchContentTypes()
    .then((contentTypes) => {
      return contentTypes
    })
}

function displayEntries (contentTypes) {
  return Promise.all(contentTypes.map((contentType) => {
    return fetchEntriesForContentType(contentType)
      .then((entries) => {
        return entries.map((entry) => {
          return entry.fields
        })
      })
  }))
}

// Load all Content Types in your space from Contentful
function fetchContentTypes () {
  return client.getContentTypes()
    .then((response) => response.items)
    .catch((error) => {
      console.error(error)
    })
}

// Load all entries for a given Content Type from Contentful
function fetchEntriesForContentType (contentType) {
  return client.getEntries({
    content_type: contentType.sys.id
  })
    .then((response) => response.items)
    .catch((error) => {
      console.error(error)
    })
}

// Start the boilerplate code
export default runBoilerplate



// WEBPACK FOOTER //
// ./src/contentful.js